//Reset data
export const RESET = "WIDGETS_MODAL_RESET"

//Loading
export const SET_TOGGLE_LOADING = "WIDGETS_MODAL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "WIDGETS_MODAL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "WIDGETS_MODAL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "WIDGETS_MODAL_SET_MESSAGE"
export const SET_IS_SUCCESS = "WIDGETS_MODAL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "WIDGETS_MODAL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "WIDGETS_MODAL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "WIDGETS_MODAL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "WIDGETS_MODAL_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "WIDGETS_MODAL_SET_CREATED"
export const SET_IS_CREATED = "WIDGETS_MODAL_SET_IS_CREATED"
export const SET_NOT_CREATED = "WIDGETS_MODAL_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "WIDGETS_MODAL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "WIDGETS_MODAL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "WIDGETS_MODAL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "WIDGETS_MODAL_SET_HIDE_MODAL"


export const SET_MODAL = "WIDGETS_MODAL_SET_MODAL"
export const SET_MODAL_CONTENT = "WIDGETS_MODAL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "WIDGETS_MODAL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "WIDGETS_MODAL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "WIDGETS_MODAL_SET_MODAL_TYPE"